export default "__VITE_ASSET__Dmng5zOy__"